// FavouriteItem Component

import React, { Component } from 'react'
import PropTypes from 'prop-types'
import $ from 'jquery'
import classnames from 'classnames'

import Util from '../../../lib/util.jsx'
import { buildTimer } from '../../../common/timer/timer.js'
import timerStates from '../../../../shared/util/timer/timerStates.js'
class FavouriteItem extends Component {
  constructor (props) {
    super(props)

    this.data = {
      disableClick: false
    }
  }

  static get propTypes () {
    return {
      items: PropTypes.array,
      timer: PropTypes.object,
      activeDate: PropTypes.object,
      onOpenForm: PropTypes.func,
      onShowDetailForm: PropTypes.func,
      onCreateTimeCard: PropTypes.func
    }
  }

  static get defaultProps () {
    return {
      items: [],
      timer: buildTimer(null),
      activeDate: null,
      onOpenForm: null,
      onShowDetailForm: null,
      onCreateTimeCard: null
    }
  }

  componentDidMount () {
    this._updateContentWidth()
  }

  _updateContentWidth () {
    const cols = $('.favourite-item.inner')
    let width = 0

    for (let i = 1; i <= cols.length; i++) {
      const itemWidth = cols.eq(i - 1).outerWidth()
      width += itemWidth
    }

    if (width > 0) {
      $('.cont.outer').css('min-width', `${width}px`)
    }
  }

  render () {
    const _className = classnames('favourite-item', {
      disableclick: this.data.disableClick
    })

    return (
      <div className={_className}>
        <div className='cont outer'>{this._rendertimeCards()}</div>
      </div>
    )
  }

  _rendertimeCards () {
    const items = this.props.items
    if (items && items.length > 0) {
      return items.map((item, idx) => (
        <div
          className='favourite-item inner'
          key={idx}
          onClick={
            this.data.disableClick ? null : this._onClickItem.bind(this, item)
          }
        >
          <div className='cont'>
            {item.activityId ? (
              <div className='title'>
                {item.project.title ? item.project.title : ''}
              </div>
            ) : (
              <div className='title'>{item.customActivityType}</div>
            )}
            <span className='info'>{item.customActivityType}</span>
          </div>
        </div>
      ))
    }

    return ''
  }

  _onClickItem (item) {
    if (!this.data.disableClick) {
      if (this._clickTimer) window.clearTimeout(this._clickTimer)

      this.data.disableClick = true
      this.setState({ dataDate: new Date() })

      this._onClickItemProcess(item, () => {
        this._clickTimer = window.setTimeout(() => {
          this.data.disableClick = false
          this.setState({ dataDate: new Date() })
        }, 1000)
      })
    }
  }

  _onClickItemProcess (item, callback) {
    if (Util.isDateEqual(new Date(item.createdOn), this.props.activeDate)) {
      // If no timer running, show manual time update form
      if (!this._isTimerStarted(item)) {
        if (this.props.onOpenForm) {
          this.props.onOpenForm(item)
        }

        callback(null)
      } else {
        // If has active timer, show the details form
        if (this.props.onShowDetailForm) {
          this.props.onShowDetailForm(item)
        }

        callback(null)
      }
    } else {
      if (this.props.onCreateTimeCard) {
        const createData = {
          projectId: item.projectId ? item.projectId : null,
          activityId: item.activityId ? item.activityId : null,
          userId: item.userId,
          activity: item.customActivityType
        }
        this.props.onCreateTimeCard(createData, false, true, callback)
      } else {
        callback(null)
      }
    }
  }

  _getStatus (item) {
    const { timer } = this.props

    return timer.doesRelateToTimeCardId(item.id) ? timer.Status() : ''
  }

  _isTimerStarted (item) {
    return this._getStatus(item) === timerStates.STARTED
  }
}

export default FavouriteItem
